/**
 * External dependencies
 */
import React from 'react';

const SchemeIcon = ({ color1, color2, color3 }) => {
	return (
		<svg width='15' height='15' viewBox='0 0 50 50'>
			<rect x='1' y='1' fill={color1} width='24' height='48'></rect>
			<rect x='25' y='1' fill={color2} width='24' height='24'></rect>
			<rect x='25' y='25' fill={color3} width='24' height='24'></rect>
		</svg>
	);
};

export default SchemeIcon;
